import { Entity, EntityConfiguration, Schema } from '@technocom/data/core';

export interface LanguageContentDTO {
  id: number;
  language: string;
  content: string;
}

export class LanguageContent<T extends LanguageContentDTO = LanguageContentDTO> extends Entity<T> {
  static readonly options: EntityConfiguration = Entity.extendOptions({
    title: 'Языковое содержимое',
  });

  static readonly extras = Entity.extendExtras({
    ignoreParseFields: ['id', 'language'] as Array<keyof LanguageContentDTO>,
  });

  static readonly schema: Schema = Entity.extend<LanguageContentDTO>({
    fields: {
      id: {
        type: Number,
      },
      content: {
        type: String,
      },
      language: {
        type: String,
      },
    },
  });
}
